function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

Shopify.addItem = function(variant_id, qty, properties, callback) {
  var qty = qty || 1;
  var params = {
    quantity: qty,
    id: variant_id
  }
  if(properties != false){
    params.properties = properties;
  }
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: params,
    dataType: "json",
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  });
};

  $(document).ready(function(){
    var sum = 0;
    $('body .quant').each(function() {
        sum += Number($(this).text());
    });

    $('.aocount').text(sum);
    mealcount = parseInt($('#cart-icon-bubble > div > span:nth-child(1)').text()) - parseInt(sum);
    $('.mealcount').text(mealcount);
    setTimeout(function(){
      barChange();
    },600);
  });

  function fireTierConfetti(percent) {
    const drawer = document.querySelector('#ff-mini-cart');
    if (!drawer) return;

    const rect = drawer.getBoundingClientRect();
    const xCenter = rect.left + rect.width / 2;
    const yBottom = rect.top + rect.height;

    confetti({
      particleCount: 100,
      spread: 70,
      origin: {
        x: xCenter / window.innerWidth,
        y: yBottom / window.innerHeight
      },
      colors: ['#1c8f2a', '#4cd137'], // FitFoodie green palette
      zIndex: 999999
    });

    // Optional BIG blast for 10% tier
    if (percent === 10) {
      setTimeout(() => {
        confetti({
          particleCount: 180,
          spread: 100,
          origin: {
            x: xCenter / window.innerWidth,
            y: yBottom / window.innerHeight
          },
          colors: ['#1c8f2a', '#4cd137', '#ffdd00', '#ffffff'], // add gold & white celebration
          zIndex: 999999
        });
      }, 300);
    }
  }

  function barChange() {
    if(parseInt($('.cartcount').text()) == 0) {
      //$('#freemealbar-container').parent().animate({"height":"95px"},500);
      $('#freemealbar-container').slideDown(500);
      $('#freemealbar').animate({
        "width": (100 - (10*(10 - parseInt($('.cartcount').text()))))+'%'
      },600);

      $('#freemealbar-label span:first').text((10 - parseInt($('.cartcount').text())));
      $('.percentage').text('5%');
      $('#freemealbar-label').show();
      $('#freemealbar-label-done').hide();
    } else if(parseInt($('.cartcount').text()) > 0 && parseInt($('.cartcount').text()) < 10) {
      //$('#freemealbar-container').parent().animate({"height":"95px"},500);
      $('#freemealbar-container').slideDown(500);
      $('#freemealbar').animate({
        "width": (100 - (10*(10 - parseInt($('.cartcount').text()))))+'%'
      },600);

      $('#freemealbar-label span:first').text((10 - parseInt($('.cartcount').text())));
      $('.percentage').text('5%');
      $('#freemealbar-label').show();
      $('#freemealbar-label-done').hide();
    } else if(parseInt($('.cartcount').text()) == 10) {
      //$('#freemealbar-container').parent().animate({"height":"95px"},500);
      $('#freemealbar-container').slideDown(500);
      $('#freemealbar').animate({
        "width": (100 - (10*(15 - parseInt($('.cartcount').text()))))+'%'
      },600);

      fireTierConfetti((100 - (10*(10 - parseInt($('.cartcount').text())))));

      $('#freemealbar-label span:first').text((15 - parseInt($('.cartcount').text())));
      $('.percentage').text('10%');
      $('#freemealbar-label').show();
      $('#freemealbar-label-done').hide();
    } else if(parseInt($('.cartcount').text()) > 10 && parseInt($('.cartcount').text()) < 15) {
      //$('#freemealbar-container').parent().animate({"height":"95px"},500);
      $('#freemealbar-container').slideDown(500);
      $('#freemealbar').animate({
        "width": (100 - (10*(15 - parseInt($('.cartcount').text()))))+'%'
      },600);

      $('#freemealbar-label span:first').text((15 - parseInt($('.cartcount').text())));
      $('.percentage').text('10%');

      $('#freemealbar-label').show();
      $('#freemealbar-label-done').hide();
    } else if(parseInt($('.cartcount').text()) > 15) {
      //$('#freemealbar-container').parent().animate({"height":"95px"},500);
      $('#freemealbar-container').slideDown(500);
      $('#freemealbar').animate({
        "width":"100%"
      },600);

      $('#freemealbar-label').hide();
      $('#freemealbar-label-done').show();
    } else if(parseInt($('.cartcount').text()) == 15) {
      //$('#freemealbar-container').parent().animate({"height":"95px"},500);
      $('#freemealbar-container').slideDown(500);
      $('#freemealbar').animate({
        "width":"100%"
      },600);

      fireTierConfetti(10);

      $('#freemealbar-label').hide();
      $('#freemealbar-label-done').show();
    }

    setTimeout(function(){
      jQuery.getJSON('/cart.js', function(cart) {
          jQuery("span.cartcount").html(cart.item_count);
          $('#cart-icon-bubble > div > span:nth-child(1)').text(cart.item_count);

          let USDollar = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
          });
                  
          $('.cartcost').text(USDollar.format((cart.total_price/100)));
      });

      //breathing
      if(parseInt($('.cartcount').text()) < 10) {
        $('#freemealbar').addClass('tier-5');
        $('#freemealbar').removeClass('tier-10');
      } else {
        $('#freemealbar').addClass('tier-10');
        $('#freemealbar').removeClass('tier-5');
        $('#freemealbar-label').style('font-weight:800!important;');
      }
    },600);
  }

  // Update the cart total when the cart changes
  $(document).click(function() {
    setTimeout(function(){
      jQuery.getJSON('/cart.js', function(cart) {
          jQuery("span.cartcount").html(cart.item_count);
          $('#cart-icon-bubble > div > span:nth-child(1)').text(cart.item_count);

          let USDollar = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
          });
                  
          $('.cartcost').text(USDollar.format((cart.total_price/100)));
          barChange();
      });
    },600);
  });
  $('.quickplus').click(function(){
        if($(this).parent().find('.quant').text() == 9) {
          //$(this).parent().find('.quickplus').addClass('qdisabled');
        }
        //$(this).parent().find('.quickminus').removeClass('qdisabled');
        if($(this).parent().find('.quant').text() == 0) {
          q = 1;
          var thisid = $(this).attr('data-product-id');

          var params = {
            'items': [{
              'id': $(this).attr('data-product-id'),
              'quantity': 1,
              'sections': 'cart-icon-bubble'
              }]
          }
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: params,
            dataType: "json",
            success: function(line_item) {
              if ((typeof callback) === 'function') {
                callback(line_item);
                console.log(line_item);
              } else {
                //Shopify.onItemAdded(line_item);
                //$('.quant').load(document.URL+' .quant');
                var newq = 0;
                $(line_item.items).each(function( index ) {
                  if(this.id == thisid) {
                    newq += this.quantity;
                  }
                });
                $('.quant[data-product-id="'+thisid+'"').text(newq);
                jQuery("span.cartcount").html(line_item.item_count);
                $('#cart-icon-bubble > div > span:nth-child(1)').text(line_item.item_count);
                barChange();
              }
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          });
        } else if(parseInt($("span.cartcount").text()) == 111 || parseInt($("span.cartcount").text()) == 116) {
          var thisid = $(this).attr('data-product-id');
          q++;

          var itemtotal = 0;
          var linenumber = 0;
          $.ajax({
              type: 'GET',
              url: '/cart.js',
              cache: false,
              dataType: 'json',
              success: function(cart) {
                $(cart.items).each(function(index) {
                  if(this.id == thisid) {
                    //console.log('cart id '+this.id);
                    //console.log('cart quantity '+this.quantity);
                    //itemtotal += this.quantity;
                  }
                  console.log('length '+this.discounts.length);
                  console.log(this.discounts);
                  if(this.id == thisid && this.discounts.length == 0 || this.id == thisid && this.discounts.length > 0 && this.discounts[0].amount == 0) {
                    linenumber = (index + 1);
                    console.log('line '+linenumber);
                    itemtotal += this.quantity;
                  }
                });

                console.log('total '+itemtotal);

                var params = {
                  id: thisid,
                  line: linenumber,
                  quantity: (itemtotal + 1),
                  sections: 'cart-icon-bubble'
                }
                
                jQuery.ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  data: params,
                  dataType: "json",
                  success: function(line_item) {
                    if ((typeof callback) === 'function') {
                      callback(line_item);
                    } else {
                      //Shopify.onItemAdded(line_item);
                      //$('.quant').load(document.URL+' .quant');
                      var newq = 0;
                      $(line_item.items).each(function( index ) {
                        if(this.id == thisid) {
                          newq += this.quantity;
                        }
                      });
                      $('.quant[data-product-id="'+thisid+'"').text(newq);
                      jQuery("span.cartcount").html(line_item.item_count);
                      $('#cart-icon-bubble > div > span:nth-child(1)').text(line_item.item_count);
                      barChange();
                    }
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    Shopify.onError(XMLHttpRequest, textStatus);
                  }
                });
              }
          });


        } else {
          var q = parseInt($(this).parent().find('.quant:first').text(),10);
          var thisid = $(this).attr('data-product-id');
          q++;

          var params = {
            id: $(this).attr('data-product-id'),
            quantity: q,
            sections: 'cart-icon-bubble'
          }
          jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: params,
            dataType: "json",
            success: function(line_item) {
              if ((typeof callback) === 'function') {
                callback(line_item);
              } else {
                //Shopify.onItemAdded(line_item);
                //$('.quant').load(document.URL+' .quant');
                var newq = 0;
                $(line_item.items).each(function( index ) {
                  if(this.id == thisid) {
                    newq += this.quantity;
                  }
                });
                $('.quant[data-product-id="'+thisid+'"').text(newq);
                jQuery("span.cartcount").html(line_item.item_count);
                $('#cart-icon-bubble > div > span:nth-child(1)').text(line_item.item_count);
                barChange();
              }
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          });
        }
  return;
  });

    $('.quickminus').click(function(){
        if($(this).parent().find('.quant').text() == 10) {
          //$(this).parent().find('.quickplus').removeClass('qdisabled');
        }
        if($(this).parent().find('.quant').text() == 1) {
          //$(this).parent().find('.quickminus').addClass('qdisabled');
          var q = parseInt($(this).parent().find('.quant').text(),10);
          var thisid = $(this).attr('data-product-id');
          q--;

          var params = {
            id: $(this).attr('data-product-id'),
            quantity: 0,
            sections: 'cart-icon-bubble'
          }
          jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: params,
            dataType: "json",
            success: function(line_item) {
              if ((typeof callback) === 'function') {
                callback(line_item);
              } else {
                //Shopify.onItemAdded(line_item);
                //$('.quant').load(document.URL+' .quant');
                var newq = 0;
                $(line_item.items).each(function( index ) {
                  if(this.id == thisid) {
                    newq += this.quantity;
                  }
                });
                $('.quant[data-product-id="'+thisid+'"').text(0);
                jQuery("span.cartcount").html(line_item.item_count);
                $('#cart-icon-bubble > div > span:nth-child(1)').text(line_item.item_count);
                barChange();
              }
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          });
         } else {
          var q = parseInt($(this).parent().find('.quant').text(),10);
          var thisid = $(this).attr('data-product-id');
          q--;

          var params = {
            id: $(this).attr('data-product-id'),
            quantity: q,
            sections: 'cart-icon-bubble'
          }
          jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: params,
            dataType: "json",
            success: function(line_item) {
              if ((typeof callback) === 'function') {
                callback(line_item);
              } else {
                //Shopify.onItemAdded(line_item);
                //$('.quant').load(document.URL+' .quant');
                var newq = 0;
                $(line_item.items).each(function( index ) {
                  if(this.id == thisid) {
                    newq += this.quantity;
                  }
                });
                $('.quant[data-product-id="'+thisid+'"').text(newq);
                jQuery("span.cartcount").html(line_item.item_count);
                $('#cart-icon-bubble > div > span:nth-child(1)').text(line_item.item_count);
                barChange();
              }
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          });
        }
  return;
  });

$('document').ready(function(){
  var getNextDay = function (dayName) {
  
  // The current day
  var date = new Date();
  var now = date.getDay();
  
  // Days of the week
  var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  
  // The index for the day you want
  var day = days.indexOf(dayName.toLowerCase());
  
  // Find the difference between the current day and the one you want
  // If it's the same day as today (or a negative number), jump to the next week
  var diff = day - now;
  diff = diff < 1 ? 7 + diff : diff;
  
  // Get the timestamp for the desired day
  var nextDayTimestamp = date.getTime() + (1000 * 60 * 60 * 24 * diff);
  
  // Get the next day
  return new Date(nextDayTimestamp);
  
  };
            
  var dSun = getNextDay('Sunday')
  //dSun.setDate(dSun.getDate() + (((7 + 7 - dSun.getDay()) % 7) || 7));
  //$('#nextsunday').text(dSun.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}).toUpperCase());
  $('#nextsunday').text(dSun.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}).toUpperCase());
  
  var dMon = getNextDay('Monday')
  //dMon.setDate(dMon.getDate() + (((1 + 7 - dMon.getDay()) % 7) || 7));
  //$('#nextmonday').text(dMon.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}).toUpperCase());
  $('#nextmonday').text(dMon.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}).toUpperCase());
});

//mighty cart code
document.addEventListener('DOMContentLoaded', ()=>{
  const sidebar = document.getElementById('ff-cart-sidebar');
  const minidrawer = $('.ff-drawer');
  const isFullMenu = window.location.href.includes('full-menu');

  if(sidebar){
    if(isFullMenu && window.innerWidth >= 749){
      sidebar.classList.add('is-open');
      sidebar.style.display = 'flex';

      minidrawer.style.display = 'none';
    } else {
      sidebar.classList.remove('is-open');
      sidebar.style.display = 'none';

      minidrawer.style.display = 'flex';
    }
  }
});

(function(){
  const mini = document.getElementById('ff-mini-cart');
  const nativecartbtn = document.querySelector('.header__icon--cart');
  const drawer = document.getElementById('ff-cart-drawer');
  const linesWrap = drawer.querySelector('[data-ff-lines]');
  const subtotalEls = document.querySelectorAll('.ff-mini__subtotal, .ff-drawer__subtotal');
  const countEl = mini.querySelector('.ff-mini__count');

  const sidebar = document.getElementById('ff-cart-sidebar');
  const sidebarLinesWrap = sidebar ? sidebar.querySelector('[data-ff-lines]') : null;

  // Helpers
  const money = c => (c/100).toLocaleString(undefined,{style:'currency',currency:Shopify.currency.active||'USD'});

  async function getCart(){ const r = await fetch('/cart.js'); return r.json(); }
  async function change(lineItemKey, qty){
    return fetch('/cart/change.js',{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: lineItemKey, quantity: qty})}).then(r=>r.json());
  }
  async function clearCart(){ return fetch('/cart/clear.js',{method:'POST'}).then(r=>r.json()); }

  function toggleDrawer(open){
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', !open);
    mini.querySelector('.ff-mini__toggle').setAttribute('aria-expanded', !!open);
  }

  function render(cart){
    // mini + drawer still work
    countEl.textContent = cart.item_count;
    subtotalEls.forEach(el => el.textContent = money(cart.items_subtotal_price));

    const linesHTML = cart.items.map(item => `
      <div class="ff-line" data-key="${item.key}">
        <img class="ff-line__img" src="${item.image || item.featured_image?.url}" alt="">
        <div>
          <p class="ff-line__title">${item.product_title}</p>
          <div class="ff-qty">
            <button type="button" data-minus>-</button>
            <input type="text" value="${item.quantity}" inputmode="numeric" />
            <button type="button" data-plus>+</button>
          </div>
        </div>
        <div class="ff-line__price">${money(item.final_line_price)}</div>
      </div>
    `).join('');

    linesWrap.innerHTML = linesHTML;       // drawer
    if (sidebarLinesWrap) sidebarLinesWrap.innerHTML = linesHTML; // sidebar
  }

  async function refresh(){
    render(await getCart());
  }

  // Init
  refresh();

  // Open / close
  mini.querySelector('.ff-mini__toggle').addEventListener('click', async ()=>{
    if (!drawer.classList.contains('is-open')) await refresh();
    toggleDrawer(!drawer.classList.contains('is-open'));
  });
  if (window.location.href.includes('full-menu')) {
    nativecartbtn.addEventListener('click', async (e)=>{
      e.preventDefault();   // stop link to /cart
      e.stopImmediatePropagation(); // stop Shopify’s JS listeners

      if (!drawer.classList.contains('is-open')) await refresh();
      toggleDrawer(!drawer.classList.contains('is-open'));
    });
  }
  drawer.querySelector('[data-ff-close]').addEventListener('click', ()=> toggleDrawer(false));

  // Clear
  drawer.querySelector('[data-ff-clear]').addEventListener('click', async ()=>{
    await clearCart(); await refresh();
  });

  // Checkout buttons
  document.querySelectorAll('[data-ff-checkout]').forEach(btn=>{
    btn.addEventListener('click', ()=> { $('#orderinfo').fadeIn(100).style('display:flex;'); });
    //btn.addEventListener('click', ()=> { window.location.href = '/checkout'; });
  });

  // Qty handlers (event delegation)
  linesWrap.addEventListener('click', async (e)=>{
    const line = e.target.closest('.ff-line'); if(!line) return;
    const key = line.dataset.key;
    const input = line.querySelector('input');
    if(e.target.matches('.ff-line [data-plus]')) { 
      await change(key, Number(input.value)+1); 
      await refresh(); 
      document.dispatchEvent(new Event('cart:refresh'));
      barChange();
    }
    if(e.target.matches('.ff-line [data-minus]')) { 
      await change(key, Math.max(0, Number(input.value)-1)); 
      await refresh(); 
      document.dispatchEvent(new Event('cart:refresh'));
      barChange();
    }
  });
  linesWrap.addEventListener('change', async e=>{
    const line = e.target.closest('.ff-line'); if(!line || e.target.tagName!=='INPUT') return;
    const key = line.dataset.key;
    const v = Math.max(0, parseInt(e.target.value || '0', 10));
    await change(key, v); await refresh();
  });

  sidebarLinesWrap.addEventListener('click', async (e)=>{
    const line = e.target.closest('.ff-line'); if(!line) return;
    const key = line.dataset.key;
    const input = line.querySelector('input');
    if(e.target.matches('.ff-line [data-plus]')) { 
      await change(key, Number(input.value)+1); 
      await refresh(); 
      document.dispatchEvent(new Event('cart:refresh'));
    }
    if(e.target.matches('.ff-line [data-minus]')) { 
      await change(key, Math.max(0, Number(input.value)-1)); 
      await refresh(); 
      document.dispatchEvent(new Event('cart:refresh'));
    }
  });
  sidebarLinesWrap.addEventListener('change', async e=>{
    const line = e.target.closest('.ff-line'); if(!line || e.target.tagName!=='INPUT') return;
    const key = line.dataset.key;
    const v = Math.max(0, parseInt(e.target.value || '0', 10));
    await change(key, v); await refresh();
  });

  // Optional: listen for theme/cart events to keep in sync
  document.addEventListener('cart:refresh', refresh);
})();

document.addEventListener('click', async e => {
  const plus = e.target.closest('[data-plus]');
  const minus = e.target.closest('[data-minus]');
  if (!plus && !minus) return;

  const wrapper = e.target.closest('.mm-qty');
  const quantEl = wrapper.querySelector('.quant');
  const variantId = wrapper.querySelector('.variant-id').value;

  if (plus) {
    // Add 1 to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    quantEl.textContent = Number(quantEl.textContent) + 1;
    document.dispatchEvent(new Event('cart:refresh'));
  }

  if (minus) {
    let newQty = Math.max(0, Number(quantEl.textContent) - 1);
    quantEl.textContent = newQty;

    // Shopify can't "remove by product" without a line item key,
    // but we can set quantity to newQty if you first get /cart.js:
    const cart = await fetch('/cart.js').then(r => r.json());
    const line = cart.items.find(i => i.variant_id == variantId);
    if (line) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: newQty })
      });
      document.dispatchEvent(new Event('cart:refresh'));
    }
  }
});

(function(){
  async function getCart(){ 
    const r = await fetch('/cart.js'); 
    return r.json(); 
  }

  async function updateQuantities(){
    const cart = await getCart();

    // Reset all quantities to 0
    document.querySelectorAll('.mm-qty .quant').forEach(el=>{
      el.textContent = '0';
    });

    // Update based on cart items
    cart.items.forEach(item=>{
      const variantId = item.variant_id || item.id; // Shopify may use id or variant_id
      document.querySelectorAll('.mm-qty').forEach(qtyBox=>{
        const hidden = qtyBox.querySelector('.variant-id');
        if(hidden && Number(hidden.value) === variantId){
          const span = qtyBox.querySelector('.quant');
          if(span) span.textContent = item.quantity;
        }
      });
    });
  }

  // Refresh on page load
  document.addEventListener('DOMContentLoaded', updateQuantities);

  // Refresh after cart updates
  document.addEventListener('cart:refresh', updateQuantities);

  // Also trigger refresh after +/-
  document.body.addEventListener('click', e=>{
    if(e.target.matches('.quickplus, .quickminus')){
      setTimeout(()=>document.dispatchEvent(new Event('cart:refresh')),300);
    }
  });
})();

$(function() {
  if (!window.location.href.includes('full-menu')) return;
  $("body").addClass("fullmenu-page");

  const $main = $('#MainContent');
  const $sidebar = $('#ff-cart-sidebar');
  const $wrapper = $('<div class="ff-main-stack-wrapper"></div>');
  $main.children().not($sidebar).appendTo($wrapper);
  $main.empty().append($wrapper).append($sidebar);

  function resizeStacks() {
    const main = document.getElementById('MainContent');
    if (!main) return;

    const rect = main.getBoundingClientRect();
    const availableHeight = window.innerHeight - rect.top;

    const stack = document.querySelector('.ff-main-stack-wrapper');
    const sidebar = document.getElementById('ff-cart-sidebar');

    if (stack) {
      stack.style.height = availableHeight + 'px';
      stack.style.overflowY = 'auto';
    }
    if (sidebar) {
      sidebar.style.height = availableHeight + 'px';
      sidebar.style.overflowY = 'auto';
    }
  }

  // Run on load and resize
  window.addEventListener('load', resizeStacks);
  window.addEventListener('resize', resizeStacks);
  window.addEventListener('orientationchange', resizeStacks);
});

$(document).ready(function() {
  if (window.location.href.includes('full-menu') && $(window).width() >= 749) {
    // Build a blank card element
    var blankCard = `
      <li class="grid__item account-card">
        <div class="mm-card-wrapper">
          <article class="mm-card-vertical mm-card--account">
            <div class="mm-card__body account-card__body">
              <h3 class="mm-title">Welcome Back</h3>
              <div class="account-data">
                <p><strong>You've placed </strong> <span id="meals-ordered">`+window.customer.orders_count+`</span> orders, 
                saving <strong>~`+((window.customer.total_spent / 10)*20)+` mins</strong> cooking.</p>
              </div>
            </div>
          </article>
        </div>
      </li>
    `;

    // Append it at the end of the grid
    // $("#product-grid").append(blankCard);

    // Or prepend to top of grid:
    // $("#product-grid").prepend(blankCard);

    // Or insert after a specific card:
    // $(".grid__item").eq(2).after(blankCard);

    // Disable Shopify QuantityInput (so it doesn't bind twice)
    if (customElements.get('quantity-input')) {
      customElements.define('quantity-input', class extends HTMLElement {
        connectedCallback() {
          // no-op → don't attach listeners
        }
      });
    }

    // Disable Shopify cart drawer openers
    const nativeCartBtn = document.querySelector('.header__icon--cart');
    if (nativeCartBtn) {
      const clone = nativeCartBtn.cloneNode(true);
      nativeCartBtn.parentNode.replaceChild(clone, nativeCartBtn);
      // now rebind your own
      clone.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        document.getElementById('ff-cart-sidebar').classList.add('is-open');
      });
    }
  }
});
document.addEventListener("DOMContentLoaded", ()=>{
  const referBtn = document.querySelector(".refer-btn");
  const toast = document.getElementById("toast");

  if (referBtn) {
    referBtn.addEventListener("click", async ()=>{
      // Build referral link
      const name = (window.customer?.first_name || "guest").toLowerCase();
      const id = window.customer?.id?.toString().slice(-2) || "00";
      const link = `https://fitfoodiesa.com/?ref=${name}${id}`;

      try {
        await navigator.clipboard.writeText(link);
        toast.classList.add("show");
        setTimeout(()=> toast.classList.remove("show"), 4000);
      } catch(err) {
        console.error("Copy failed", err);
      }
    });
  }
});